/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import { Button } from 'react-bootstrap';
import InputAdornment from '@mui/material/InputAdornment';
import { setDefaultSysParamDataRedux } from '../store/actions';
import { validateMaxLength } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';

function DefaultSystemParameters(props) {
  const dispatch = useDispatch();
  const {
    setUpdateDefSysparameter,
    setDisabledSaveCancelBtn,
    setSystemParameterData,
    isReadOnly,
    isEnabledByRole,
    disabledSaveCancelBtn,
  } = props;
  const payload = useSelector(
    (state) =>
      state?.sharedState?.SystemProviderReducer?.generalSystemParameter
        ?.paramGeneralVO
  );
  const defSysParamData = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.defSysParamData
  );
  const [showDisputesOnInvoice, setShowDisputesOnInvoice] = useState(false);
  const [autoUnderThreshold, setAutoUnderThreshold] = useState(false);
  const [forgiveRequiresComments, setForgiveRequiresComments] = useState(false);
  const [showViewHistory, setShowViewHistory] = useState(false);
  const [keyValue, setKeyValue] = useState([]);
  const [unitConversionChangesData, setUnitConversionChangesData] =
    useState(false);
  const [permitNonZeroBilledUnits, setPermitNonZeroBilledUnits] =
    useState(false);
  const [reimbursementMultiplier, setReimbursementMultiplier] = useState(
    payload && payload.length > 0 ? payload[0].defReimbUnderThresholdMult : null
  );
  const [invoiceMail, setInvoiceMail] = useState(
    payload && payload.length > 0 ? payload[0].defInvoiceMailThreshold : null
  );
  const [sendAllRetainedQuarter, setSendAllRetainedQuarter] = useState(
    payload && payload.length > 0 ? payload[0].defSendAllRetainedQtr : null
  );
  const [windowPosition, setWindowPosition] = useState(
    payload && payload.length > 0 ? payload[0].defWindowAddrPos : null
  );
  const [dataSet, setDataSet] = useState({
    allowNewCgpInd: null,
    preventCcUpdateInd: null,
    checkLogByCcnInd: null,
    strongPwReqInd: null,
    checkLogUsesBatchInd: null,
    drugGrossAmtInd: null,
    hideCmsUraInd: null,
    showSpecialTheraClassInd: null,
    ftpCmsTapeInd: null,
    secLoginInd: null,
    ftpIpAddress: null,
    ftpUserId: null,
    ftpPassword: null,
    secLoginMsg: null,
    aboutMessageText: null,
    extFileDir: null,
  });
  const validNumber = new RegExp(/^\d*\.?\d*$/);

  const updateDefSysparameter = {
    defSendAllRetainedQtr: null,
    defWindowAddrPos: null,
    defInvoiceMailThreshold: null,
    defReimbUnderThresholdMult: null,
    defNonZeroBilledUnitsInd: null,
    defUnitConvChangesDataInd: null,
    defForgiveReqCommentInd: null,
    defAutoUnderThresholdInd: null,
    defShowDisputeOnInvInd: null,
  }; 
  const fieldMap = {
    showDisputesOnInvoice: "defShowDisputeOnInvInd",
    autoUnderThreshold: "defAutoUnderThresholdInd",
    forgiveRequiresComments: "defForgiveReqCommentInd",
    unitConversionChangesData: "defUnitConvChangesDataInd",
    permitNonZeroBilledUnits: "defNonZeroBilledUnitsInd",
    ReimbursementMultiplier: "defReimbUnderThresholdMult",
    invoiceMail: "defInvoiceMailThreshold",
    windowPosition: "defWindowAddrPos",
    sendAllRetainedQuarter: "defSendAllRetainedQtr",
  };

  const toNumberFlag = (val) => (val ? 1 : 0);

  const buildMergedDefaults = (base, overrides = {}) => ({
    defShowDisputeOnInvInd:
      overrides.defShowDisputeOnInvInd ?? base?.defShowDisputeOnInvInd ?? 0,
    defAutoUnderThresholdInd:
      overrides.defAutoUnderThresholdInd ?? base?.defAutoUnderThresholdInd ?? 0,
    defForgiveReqCommentInd:
      overrides.defForgiveReqCommentInd ?? base?.defForgiveReqCommentInd ?? 0,
    defUnitConvChangesDataInd:
      overrides.defUnitConvChangesDataInd ??
      base?.defUnitConvChangesDataInd ??
      0,
    defNonZeroBilledUnitsInd:
      overrides.defNonZeroBilledUnitsInd ?? base?.defNonZeroBilledUnitsInd ?? 0,
    defReimbUnderThresholdMult:
      overrides.defReimbUnderThresholdMult ??
      base?.defReimbUnderThresholdMult ??
      null,
    defInvoiceMailThreshold:
      overrides.defInvoiceMailThreshold ??
      base?.defInvoiceMailThreshold ??
      null,
    defSendAllRetainedQtr:
      overrides.defSendAllRetainedQtr ?? base?.defSendAllRetainedQtr ?? null,
    defWindowAddrPos:
      overrides.defWindowAddrPos ?? base?.defWindowAddrPos ?? null,
  });

  const handleChange = (event, field) => {
    setDisabledSaveCancelBtn(false);
    const base = payload?.[0] || {};
    const currentFull = buildMergedDefaults(base, dataSet); 
    const isCheckbox =
      field === "showDisputesOnInvoice" ||
      field === "autoUnderThreshold" ||
      field === "forgiveRequiresComments" ||
      field === "unitConversionChangesData" ||
      field === "permitNonZeroBilledUnits";
    const value = isCheckbox
      ? toNumberFlag(event.target.checked)
      : event.target.value;
    const backendKey = fieldMap[field];
    const next = {
      ...currentFull,
      ...(backendKey ? { [backendKey]: value } : {}),
    }; 
    if (field === "showDisputesOnInvoice") setShowDisputesOnInvoice(!!value);
    if (field === "autoUnderThreshold") setAutoUnderThreshold(!!value);
    if (field === "forgiveRequiresComments")
      setForgiveRequiresComments(!!value);
    if (field === "unitConversionChangesData")
      setUnitConversionChangesData(!!value);
    if (field === "permitNonZeroBilledUnits")
      setPermitNonZeroBilledUnits(!!value);
    if (field === "ReimbursementMultiplier") setReimbursementMultiplier(value);
    if (field === "invoiceMail") setInvoiceMail(value);
    if (field === "windowPosition") setWindowPosition(value);
    if (field === "sendAllRetainedQuarter") setSendAllRetainedQuarter(value);
    setDataSet(next);
    setUpdateDefSysparameter(next);
    dispatch(setDefaultSysParamDataRedux(next));
  };
  useEffect(() => {
    if (!payload || !payload[0]) return;

    const merged = buildMergedDefaults(payload[0], defSysParamData);

    setShowDisputesOnInvoice(!!merged.defShowDisputeOnInvInd);
    setAutoUnderThreshold(!!merged.defAutoUnderThresholdInd);
    setForgiveRequiresComments(!!merged.defForgiveReqCommentInd);
    setUnitConversionChangesData(!!merged.defUnitConvChangesDataInd);
    setPermitNonZeroBilledUnits(!!merged.defNonZeroBilledUnitsInd);
    setReimbursementMultiplier(merged.defReimbUnderThresholdMult);
    setInvoiceMail(merged.defInvoiceMailThreshold);
    setSendAllRetainedQuarter(merged.defSendAllRetainedQtr);
    setWindowPosition(merged.defWindowAddrPos);
    setDataSet(merged);
    setSystemParameterData(payload[0]);
  }, [payload, defSysParamData]);
  useEffect(() => {
    if (defSysParamData && !disabledSaveCancelBtn) {
      setShowDisputesOnInvoice(defSysParamData.defShowDisputeOnInvInd);
      setAutoUnderThreshold(defSysParamData.defAutoUnderThresholdInd);
      setForgiveRequiresComments(defSysParamData.defForgiveReqCommentInd);
      setUnitConversionChangesData(defSysParamData.defUnitConvChangesDataInd);
      setPermitNonZeroBilledUnits(defSysParamData.defNonZeroBilledUnitsInd);
      setReimbursementMultiplier(defSysParamData.defReimbUnderThresholdMult);
      setInvoiceMail(defSysParamData.defInvoiceMailThreshold);
      setSendAllRetainedQuarter(defSysParamData.defSendAllRetainedQtr);
      setWindowPosition(defSysParamData.defWindowAddrPos);
      setDataSet(defSysParamData);
    } else if (payload && payload[0]) {
      if (payload[0].defShowDisputeOnInvInd) {
        updateDefSysparameter.updateDefSysparameter = 1;
        setShowDisputesOnInvoice(true);
      } else {
        updateDefSysparameter.updateDefSysparameter = 0;
        setShowDisputesOnInvoice(false);
      }
      if (payload[0].defAutoUnderThresholdInd) {
        updateDefSysparameter.defAutoUnderThresholdInd = 1;
        setAutoUnderThreshold(true);
      } else {
        updateDefSysparameter.defAutoUnderThresholdInd = 0;
        setAutoUnderThreshold(false);
      }
      if (payload[0].defForgiveReqCommentInd) {
        updateDefSysparameter.defForgiveReqCommentInd = 1;
        setForgiveRequiresComments(true);
      } else {
        updateDefSysparameter.defForgiveReqCommentInd = 0;
        setForgiveRequiresComments(false);
      }
      if (payload[0].defUnitConvChangesDataInd) {
        updateDefSysparameter.defUnitConvChangesDataInd = 1;
        setUnitConversionChangesData(true);
      } else {
        updateDefSysparameter.defUnitConvChangesDataInd = 0;
        setUnitConversionChangesData(false);
      }
      if (payload[0].defNonZeroBilledUnitsInd) {
        updateDefSysparameter.defNonZeroBilledUnitsInd = 1;
        setPermitNonZeroBilledUnits(true);
      } else {
        updateDefSysparameter.defNonZeroBilledUnitsInd = 0;
        setPermitNonZeroBilledUnits(false);
      }

      setReimbursementMultiplier(payload[0].defReimbUnderThresholdMult);
      setInvoiceMail(payload[0].defInvoiceMailThreshold);
      setSendAllRetainedQuarter(payload[0].defSendAllRetainedQtr);
      setWindowPosition(payload[0].defWindowAddrPos);
      setDataSet(updateDefSysparameter);
      setSystemParameterData(payload[0]);
    }
  }, [payload]);

  const handleViewHistory = () => {
    setShowViewHistory(true);
    setKeyValue({
      LAST_UPDATE_DT: payload[0].lastUpdateDt,
    });
  };

  return (
    <>
      <div className="panel mb-2">
        <div className="row">
          <div className="col-md">
            <fieldset className="custom-fieldset">
              <legend className="same-font-family">
                Rebate Program Default Values
              </legend>
              {/* <form autoComplete="off"> */}
              <div className="form-wrapper form-wrapper-col-2">
                <div className="mui-custom-form input-md">
                  <TextField
                    id="invoice_mail_threshold"
                    label="Invoice Mail Threshold"
                    fullWidth
                    onChange={(e) => {
                      const validValue = validateMaxLength(
                        e.target.value,
                        9,
                        2
                      );
                      if (
                        (validNumber.test(e.target.value) && validValue) ||
                        e.target.value === ''
                      )
                        handleChange(e, 'invoiceMail');
                    }}
                    disabled={isReadOnly || !isEnabledByRole}
                    value={invoiceMail || ''}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      inputProps: { min: 0, max: 9 },
                      startAdornment: (
                        <InputAdornment className="prefix-symbol">
                          $
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                <div className="mui-custom-form min-md pl-2">
                  <div className="sub-radio text-black sub-label mt-4">
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          disabled={isReadOnly || !isEnabledByRole}
                          onChange={(e) => {
                            handleChange(e, 'autoUnderThreshold');
                          }}
                          checked={autoUnderThreshold}
                        />
                      }
                      label="Auto Under Threshold"
                      labelPlacement="end"
                    />
                  </div>
                </div>
              </div>
              <div className="form-wrapper form-wrapper-col-2">
                <div className="mui-custom-form input-md">
                  <TextField
                    id="reimbursement_under_threshold_multiplier"
                    label="Reimbursement Under-Threshold Multiplier"
                    fullWidth
                    placeholder=""
                    disabled={isReadOnly || !isEnabledByRole}
                    inputProps={{
                      maxLength: 3,
                      inputMode: 'numeric',
                      pattern: '[0-9]*',
                    }}
                    onChange={(e) => {
                      if (validNumber.test(e.target.value))
                        handleChange(e, 'ReimbursementMultiplier');
                    }}
                    value={reimbursementMultiplier || ''}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </div>
                <div className="mui-custom-form input-md">
                  <TextField
                    id="send_all_retained_quarter"
                    label="Send All Retained Quarter"
                    fullWidth
                    placeholder=""
                    disabled={isReadOnly || !isEnabledByRole}
                    inputProps={{
                      maxlength: 1,
                    }}
                    onChange={(e) => {
                      const re = /^[0-9\b]+$/;
                      if (e.target.value === '' || re.test(e.target.value)) {
                        handleChange(e, 'sendAllRetainedQuarter');
                      }
                    }}
                    value={sendAllRetainedQuarter || ''}
                    InputLabelProps={{
                      shrink: true,
                      inputProps: { min: 0 },
                    }}
                  />
                </div>
              </div>
              <div className="form-wrapper form-wrapper-col-2">
                <div className="mui-custom-form no-margin min-md pl-4">
                  <div className="sub-radio text-black sub-label mt-4">
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          disabled={isReadOnly || !isEnabledByRole}
                          onChange={(e) => {
                            handleChange(e, 'showDisputesOnInvoice');
                          }}
                          checked={showDisputesOnInvoice}
                        />
                      }
                      label="Show Disputes On Invoice"
                      labelPlacement="end"
                    />
                  </div>
                </div>
                <div className="mui-custom-form no-margin min-md pl-4">
                  <div className="sub-radio text-black sub-label mt-4">
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          disabled={isReadOnly || !isEnabledByRole}
                          onChange={(e) => {
                            handleChange(e, 'forgiveRequiresComments');
                          }}
                          checked={forgiveRequiresComments}
                        />
                      }
                      label="Forgive Requires Comments"
                      labelPlacement="end"
                    />
                  </div>
                </div>
              </div>
              <div className="form-wrapper form-wrapper-col-2">
                <div className="mui-custom-form no-margin min-md pl-4">
                  <div className="sub-radio text-black sub-label mt-4">
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          disabled={isReadOnly || !isEnabledByRole}
                          onChange={(e) => {
                            handleChange(e, 'unitConversionChangesData');
                          }}
                          checked={unitConversionChangesData}
                        />
                      }
                      label="Unit Conversion Changes Data"
                      labelPlacement="end"
                    />
                  </div>
                </div>
                <div className="mui-custom-form no-margin min-md pl-4">
                  <div className="sub-radio text-black sub-label mt-4">
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          disabled={isReadOnly || !isEnabledByRole}
                          onChange={(e) => {
                            handleChange(e, 'permitNonZeroBilledUnits');
                          }}
                          checked={permitNonZeroBilledUnits}
                        />
                      }
                      label="Permit Non_Zero Billed Units"
                      labelPlacement="end"
                    />
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div className="col-sm-4">
            <fieldset className="custom-fieldset">
              <legend className="same-font-family">
                General System Default Values
              </legend>
              <div className="mui-custom-form with-select input-md override-width-95">
                <TextField
                  id="window_address_position"
                  label="Window Address Position"
                  fullWidth
                  placeholder=""
                  disabled={isReadOnly || !isEnabledByRole}
                  inputProps={{ maxlength: 2 }}
                  onChange={(e) => {
                    handleChange(e, 'windowPosition');
                  }}
                  value={windowPosition || ''}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
            </fieldset>
          </div>
          <div className="col-12">
            <div className="btn-wrapper float-right mr-4 mt-2">
              <Button
                className="btn btn-success btn-save btn-primary"
                data-testid="view-history"
                type="button"
                onClick={() => {
                  handleViewHistory();
                }}
              >
                <SVGComponent iconName="Icon-view-history" /> View History
              </Button>
            </div>
          </div>
        </div>
      </div>
      {showViewHistory && (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName="PARAM_GENERAL"
          keyValue={keyValue}
        />
      )}
    </>
  );
}
export default withRouter(DefaultSystemParameters);
